function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Event Dispatcher module is used for registering listeners and dispatching
 * events across amCharts system.
 */
/**
 * ============================================================================
 * IMPORTS
 * ============================================================================
 * @hidden
 */
import { Disposer, MultiDisposer } from "./Disposer";
import * as $array from "./Array";
import * as $type from "./Type";
/**
 * Universal Event Dispatcher.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/events/} for more info
 */
export var EventDispatcher = /*#__PURE__*/function () {
  /**
   * Constructor
   */
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);
    Object.defineProperty(this, "_listeners", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_killed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_disabled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_iterating", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_enabled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._listeners = [];
    this._killed = [];
    this._disabled = {};
    this._iterating = 0;
    this._enabled = true;
    this._disposed = false;
  }
  /**
   * Returns if this object has been already disposed.
   *
   * @return Disposed?
   */
  _createClass(EventDispatcher, [{
    key: "isDisposed",
    value: function isDisposed() {
      return this._disposed;
    }
    /**
     * Dispose (destroy) this object.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._disposed) {
        this._disposed = true;
        var a = this._listeners;
        this._iterating = 1;
        this._listeners = null;
        this._disabled = null;
        try {
          $array.each(a, function (x) {
            x.disposer.dispose();
          });
        } finally {
          this._killed = null;
          this._iterating = null;
        }
      }
    }
    /**
     * Checks if this particular event dispatcher has any listeners set.
     *
     * @return Has listeners?
     */
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return this._listeners.length !== 0;
    }
    /**
     * Checks if this particular event dispatcher has any particular listeners set.
     *
     * @return Has particular event listeners?
     */
  }, {
    key: "hasListenersByType",
    value: function hasListenersByType(type) {
      return $array.any(this._listeners, function (x) {
        return (x.type === null || x.type === type) && !x.killed;
      });
    }
    /**
     * Enable dispatching of events if they were previously disabled by
     * `disable()`.
     */
  }, {
    key: "enable",
    value: function enable() {
      this._enabled = true;
    }
    /**
     * Disable dispatching of events until re-enabled by `enable()`.
     */
  }, {
    key: "disable",
    value: function disable() {
      this._enabled = false;
    }
    /**
     * Enable dispatching particular event, if it was disabled before by
     * `disableType()`.
     *
     * @param type Event type
     */
  }, {
    key: "enableType",
    value: function enableType(type) {
      delete this._disabled[type];
    }
    /**
     * Disable dispatching of events for a certain event type.
     *
     * Optionally, can set how many dispatches to skip before automatically
     * re-enabling the dispatching.
     *
     * @param type    Event type
     * @param amount  Number of event dispatches to skip
     */
  }, {
    key: "disableType",
    value: function disableType(type) {
      var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
      this._disabled[type] = amount;
    }
    /**
     * Removes listener from dispatcher.
     *
     * Will throw an exception if such listener does not exists.
     *
     * @param listener Listener to remove
     */
  }, {
    key: "_removeListener",
    value: function _removeListener(listener) {
      if (this._iterating === 0) {
        var index = this._listeners.indexOf(listener);
        if (index === -1) {
          throw new Error("Invalid state: could not remove listener");
        }
        this._listeners.splice(index, 1);
      } else {
        this._killed.push(listener);
      }
    }
    /**
     * Removes existing listener by certain parameters.
     *
     * @param once         Listener's once setting
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     */
  }, {
    key: "_removeExistingListener",
    value: function _removeExistingListener(once, type, callback, context) {
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      this._eachListener(function (info) {
        if (info.once === once &&
        // TODO is this correct ?
        info.type === type && (callback === undefined || info.callback === callback) && info.context === context) {
          info.disposer.dispose();
        }
      });
    }
    /**
     * Checks if dispatching for particular event type is enabled.
     *
     * @param type  Event type
     * @return Enabled?
     */
  }, {
    key: "isEnabled",
    value: function isEnabled(type) {
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      // TODO is this check correct ?
      return this._enabled && this._listeners.length > 0 && this.hasListenersByType(type) && this._disabled[type] === undefined;
    }
    /**
     * Removes all listeners of a particular event type
     *
     * @param type  Listener's type
     */
  }, {
    key: "removeType",
    value: function removeType(type) {
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      this._eachListener(function (info) {
        if (info.type === type) {
          info.disposer.dispose();
        }
      });
    }
    /**
     * Checks if there's already a listener with specific parameters.
     *
     * @param type      Listener's type
     * @param callback  Callback function
     * @param context   Callback context
     * @return Has listener?
     */
  }, {
    key: "has",
    value: function has(type, callback, context) {
      var index = $array.findIndex(this._listeners, function (info) {
        return info.once !== true &&
        // Ignoring "once" listeners
        info.type === type && (callback === undefined || info.callback === callback) && info.context === context;
      });
      return index !== -1;
    }
    /**
     * Checks whether event of the particular type should be dispatched.
     *
     * @param type  Event type
     * @return Dispatch?
     */
  }, {
    key: "_shouldDispatch",
    value: function _shouldDispatch(type) {
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      var count = this._disabled[type];
      if (!$type.isNumber(count)) {
        return this._enabled;
      } else {
        if (count <= 1) {
          delete this._disabled[type];
        } else {
          --this._disabled[type];
        }
        return false;
      }
    }
    /**
     * [_eachListener description]
     *
     * All of this extra code is needed when a listener is removed while iterating
     *
     * @todo Description
     * @param fn [description]
     */
  }, {
    key: "_eachListener",
    value: function _eachListener(fn) {
      var _this = this;
      ++this._iterating;
      try {
        $array.each(this._listeners, fn);
      } finally {
        --this._iterating;
        // TODO should this be inside or outside the finally ?
        if (this._iterating === 0 && this._killed.length !== 0) {
          // Remove killed listeners
          $array.each(this._killed, function (killed) {
            _this._removeListener(killed);
          });
          this._killed.length = 0;
        }
      }
    }
    /**
     * Dispatches an event immediately without waiting for next cycle.
     *
     * @param type   Event type
     * @param event  Event object
     * @todo automatically add in type and target properties if they are missing
     */
  }, {
    key: "dispatch",
    value: function dispatch(type, event) {
      if (this._shouldDispatch(type)) {
        // TODO check if it's faster to use an object of listeners rather than a single big array
        // TODO if the function throws, maybe it should keep going ?
        this._eachListener(function (listener) {
          if (!listener.killed && (listener.type === null || listener.type === type)) {
            listener.dispatch(type, event);
          }
        });
      }
    }
    /**
     * Shelves the event to be dispatched within next update cycle.
     *
     * @param type   Event type
     * @param event  Event object
     * @todo automatically add in type and target properties if they are missing
     */
    /*public dispatchLater<Key extends keyof T>(type: Key, event: T[Key]): void {
        if (this._shouldDispatch(type)) {
            this._eachListener((listener) => {
                // TODO check if it's faster to use an object of listeners rather than a single big array
                if (!listener.killed && (listener.type === null || listener.type === type)) {
                    // TODO if the function throws, maybe it should keep going ?
                    // TODO dispatch during the update cycle, rather than using whenIdle
                    $async.whenIdle(() => {
                        if (!listener.killed) {
                            listener.dispatch(type, event);
                        }
                    });
                }
            });
        }
    }*/
    /**
     * Creates, catalogs and returns an [[EventListener]].
     *
     * Event listener can be disposed.
     *
     * @param once         Listener's once setting
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @param dispatch
     * @returns An event listener
     */
  }, {
    key: "_on",
    value: function _on(once, type, callback, context, shouldClone, dispatch) {
      var _this2 = this;
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      this._removeExistingListener(once, type, callback, context);
      var info = {
        type: type,
        callback: callback,
        context: context,
        shouldClone: shouldClone,
        dispatch: dispatch,
        killed: false,
        once: once,
        disposer: new Disposer(function () {
          info.killed = true;
          _this2._removeListener(info);
        })
      };
      this._listeners.push(info);
      return info;
    }
    /**
     * Creates an event listener to be invoked on **any** event.
     *
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     */
  }, {
    key: "onAll",
    value: function onAll(callback, context) {
      var shouldClone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return this._on(false, null, callback, context, shouldClone, function (_type, event) {
        return callback.call(context, event);
      }).disposer;
    }
    /**
     * Creates an event listener to be invoked on a specific event type.
     *
     * ```TypeScript
     * button.events.once("click", (ev) => {
     *   console.log("Button clicked");
     * }, this);
     * ```
     * ```JavaScript
     * button.events.once("click", (ev) => {
     *   console.log("Button clicked");
     * }, this);
     * ```
     *
     * The above will invoke our custom event handler whenever series we put
     * event on is hidden.
     *
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     */
  }, {
    key: "on",
    value: function on(type, callback, context) {
      var shouldClone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return this._on(false, type, callback, context, shouldClone, function (_type, event) {
        return callback.call(context, event);
      }).disposer;
    }
    /**
     * Creates an event listener to be invoked on a specific event type once.
     *
     * Once the event listener is invoked, it is automatically disposed.
     *
     * ```TypeScript
     * button.events.once("click", (ev) => {
     *   console.log("Button clicked");
     * }, this);
     * ```
     * ```JavaScript
     * button.events.once("click", (ev) => {
     *   console.log("Button clicked");
     * }, this);
     * ```
     *
     * The above will invoke our custom event handler the first time series we
     * put event on is hidden.
     *
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     */
  }, {
    key: "once",
    value: function once(type, callback, context) {
      var shouldClone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var x = this._on(true, type, callback, context, shouldClone, function (_type, event) {
        x.disposer.dispose();
        callback.call(context, event);
      });
      // TODO maybe this should return a different Disposer ?
      return x.disposer;
    }
    /**
     * Removes the event listener with specific parameters.
     *
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     */
  }, {
    key: "off",
    value: function off(type, callback, context) {
      this._removeExistingListener(false, type, callback, context);
    }
    /**
     * Copies all dispatcher parameters, including listeners, from another event
     * dispatcher.
     *
     * @param source Source event dispatcher
     * @ignore
     */
  }, {
    key: "copyFrom",
    value: function copyFrom(source) {
      var _this3 = this;
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      if (source === this) {
        throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
      }
      var disposers = [];
      $array.each(source._listeners, function (x) {
        // TODO is this correct ?
        if (!x.killed && x.shouldClone) {
          if (x.type === null) {
            disposers.push(_this3.onAll(x.callback, x.context));
          } else if (x.once) {
            disposers.push(_this3.once(x.type, x.callback, x.context));
          } else {
            disposers.push(_this3.on(x.type, x.callback, x.context));
          }
        }
      });
      return new MultiDisposer(disposers);
    }
  }]);
  return EventDispatcher;
}();
/**
 * A version of the [[EventDispatcher]] that dispatches events for a specific
 * target object.
 *
 * @ignore
 */
export var TargetedEventDispatcher = /*#__PURE__*/function (_EventDispatcher) {
  _inherits(TargetedEventDispatcher, _EventDispatcher);
  var _super = _createSuper(TargetedEventDispatcher);
  /**
   * Constructor
   *
   * @param target Event dispatcher target
   */
  function TargetedEventDispatcher(target) {
    var _this4;
    _classCallCheck(this, TargetedEventDispatcher);
    _this4 = _super.call(this);
    /**
     * A target object which is originating events using this dispatcher.
     */
    Object.defineProperty(_assertThisInitialized(_this4), "target", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    _this4.target = target;
    return _this4;
  }
  /**
   * Copies all dispatcher parameters, including listeners, from another event
   * dispatcher.
   *
   * @param source Source event dispatcher
   * @ignore
   */
  _createClass(TargetedEventDispatcher, [{
    key: "copyFrom",
    value: function copyFrom(source) {
      var _this5 = this;
      if (this._disposed) {
        throw new Error("EventDispatcher is disposed");
      }
      if (source === this) {
        throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
      }
      var disposers = [];
      $array.each(source._listeners, function (x) {
        // TODO very hacky
        if (x.context === source.target) {
          return;
        }
        // TODO is this correct ?
        if (!x.killed && x.shouldClone) {
          if (x.type === null) {
            disposers.push(_this5.onAll(x.callback, x.context));
          } else if (x.once) {
            disposers.push(_this5.once(x.type, x.callback, x.context));
          } else {
            disposers.push(_this5.on(x.type, x.callback, x.context));
          }
        }
      });
      return new MultiDisposer(disposers);
    }
  }]);
  return TargetedEventDispatcher;
}(EventDispatcher);